import styled from 'styled-components';

const ModalContent = styled.div `
  padding: 32px;
  flex-grow: ${props => props.flexGrow};
`;

export { ModalContent };
